import type { TierIIChemicalCandidate } from '../types/reporting.ts';
const percent = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 6 });
export function concentrationExclusionLabel(
  exclusion: NonNullable<TierIIChemicalCandidate['products'][number]['concentrationExclusion']>,
) {
  return (
    'Below concentration cutoff: ' + percent.format(exclusion.concentration) + ' ≤ ' + percent.format(exclusion.cutoff)
  );
}
